export default __webpack_public_path__ + "static/media/rehack-10.8af07157.png";